import { useIntl } from 'react-intl';
import { Divider, Form } from 'antd';

import { PageProps } from '@/types/PageProps';

import TabContentWrapper from '@/components/_common/TabContentWrapper';
import { SaveButton } from '@/components/_common/Buttons';
import AccountReceivableCreateForm from '@/components/Registry/BillToReceive/AccountReceivableForm';
import { AccountReceivableFormValues } from '@/core/domain/financial/AccountReceivable/AccountReceivable.types';
import { useAccountReceivableCreate } from '@/core/domain/financial/AccountReceivable/AccountReceivable.hooks';
import { useHistory } from 'react-router-dom';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import ButtonBack from '@/components/_common/ButtonBack';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';

function ReleasesBillToReceiveCreatePage({ route }: PageProps) {
  const intl = useIntl();
  const [form] = Form.useForm<AccountReceivableFormValues>();
  const history = useHistory();
  const accountReceivableCreate = useAccountReceivableCreate();

  async function handleSubmit() {
    try {
      const values = await form.validateFields();

      delete values.customerName;
      delete values.insurerName;
      delete values.netValue;

      const result = await accountReceivableCreate.mutateAsync({
        ...values,
        payDay: values.payDay?.format(),
        dueDate: values.dueDate?.format(),
        emissionDate: values.emissionDate?.format(),
        installmentNumber: 1,
      });

      history.push(
        `/app/financial/billToReceiver/releaseBillToReceiver/${result.id}/installment/${result.installmentReceivables.id}`,
      );
    } catch {}
  }

  return (
    <TabContentWrapper
      title={route.name}
      permissions={route.permissions}
      extra={
        <SaveButton
          type="primary"
          onClick={handleSubmit}
          loading={accountReceivableCreate.isLoading}
          disabled={
            !hasPermissions([Authorities.FINANCIAL_ACCOUNT_RECEIVABLE_ADD])
          }
        >
          {intl.formatMessage({ id: 'commons.form.button.save' })}
        </SaveButton>
      }
    >
      <AccountReceivableCreateForm form={form} />
      <Divider />

      <SpaceForButton>
        <ButtonBack path="/app/financial/billToReceiver/releaseBillToReceiver" />
      </SpaceForButton>
    </TabContentWrapper>
  );
}

export default ReleasesBillToReceiveCreatePage;
